<script setup>
import { getDatabase, query, ref as fbRef, onValue, set, onDisconnect } from "firebase/database";
import { ref, onMounted, defineProps, onUnmounted } from "vue";
import { useL24Store } from "../store/l24";
import showCaseBox from "./ui/showCaseBox.vue";
import UiSkl from "./ui/skl.vue";

import { v4 as uuidv4 } from "uuid";
import "../assets/animate.css";

import dayjs from "dayjs";
import lscache from "lscache";
lscache.setExpiryMilliseconds(1000);

let db = null;
let unsubscribeChat = null;
let roomPath = null;
const UUID = ref(null);
const initLoad = ref(false);
const initLoadRet = ref(false);

const realTimeCnt = ref(0);

if (lscache.get("UUID")) {
	UUID.value = lscache.get("UUID");
} else {
	UUID.value = uuidv4();
	lscache.set("UUID", UUID.value, 1000 * 60 * 24);
}

const store = useL24Store();
const props = defineProps({
	options: {
		type: Object,
	},
});

//data()
const wstore = ref({
	marginTop: "0",
	marginBottom: "0",
	marginLeft: "0",
	marginRight: "0",
	maxWidth: "1280px",
	title: "",
	titleFontSize: "20px",
	cardGap: "20px",
	privew: false,
	mobile: false,
	limit: 30,
});

const cacheTime = ref(10);
const isEnd = ref(false);
const init_load = ref(false);
const pageNo = ref(0);
const loading = ref(false);

const shorts1 = ref([]);
const shorts2 = ref([]);
const shorts3 = ref([]);
const shorts4 = ref([]);

const shuffleArray = (array) => {
	const arr = Array.from(array); // make a copy
	for (let i = arr.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[arr[i], arr[j]] = [arr[j], arr[i]];
	}
	return arr;
};

const ovCallBack = async () => {
	if (init_load.value && !isEnd.value && !loading.value) {
		console.log("!!ovCallBack");
		loading.value = true;
		await getPage();
	}
};
let lastRand = 0;

// 미납 체크
const checkUnpaid = async () => {
	await store.getUnpaidCheck().then((res) => {
		if (res.restricted) {
			if (top.location.href.includes("live24.app")) {
				getPage(1);
			} else {
				location.replace("/");
			}
		} else {
			getPage(1);
		}
		// console.log(res)
	});
};
const getPage = async (page) => {
	if (wstore.value.mobile) {
		wstore.value.limit = 8;
	} else {
		wstore.value.limit = 12;
	}

	if (!page) {
		pageNo.value++;
	} else {
		pageNo.value = page;
	}

	if (pageNo.value > 10) {
		isEnd.value = true;
		return;
	}

	loading.value = true;
	await store
		.getShortsShowcase({
			row_count: wstore.value.limit,
			order_col: wstore.value.orderCol,
			page_no: pageNo.value,
			cache_time: cacheTime.value,
			have_product: "Y",
		})
		.then((res) => {
			try {
				let isr = 1;
				let setVideoCnt = 0;
				let isYbV = false;

				let tstaa = Math.floor(Math.random() * 2) + 1;

				let shortsArray = [];
				let shortsArrayBase = [];
				for (let i = 0; i < store.shorts?.length; i++) {
					shortsArrayBase.push(store.shorts[i]);
				}

				shortsArray = shuffleArray(shortsArrayBase);

				for (let i = 0; i < shortsArray?.length; i++) {
					if (
						shortsArray[i].select_product_list?.length < 1 ||
						shortsArray[i].select_product_list?.length == undefined
					) {
						shortsArray[i].isVideo = true;
						shortsArray[i].isProduct = [];
					} else {
						shortsArray[i].isVideo = false;
						shortsArray[i].isProduct = shortsArray[i].select_product_list[0];
					}

					let rea3 = Math.floor(Math.random() * 6) + 1; // Increase range to 6
					if (rea3 === 1) {
						rea3 = Math.floor(Math.random() * 4) + 2; // Re-roll if 1 is selected
					}

					if (lastRand > 0) {
						if (lastRand == rea3) {
							rea3++;
							if (rea3 > 4) {
								rea3 = 4;
							}
						}
					}

					lastRand = rea3;

					if (i % rea3 == 0) {
						if (setVideoCnt < 12) {
							if (!isYbV) {
								shortsArray[i].isVideo = true;
								setVideoCnt++;
								isYbV = true;
							} else {
								isYbV = false;
							}
						}
					}

					if (tstaa == 1) {
						shortsArray[0].isVideo = false;
						shortsArray[1].isVideo = true;
						if (i % 7 == 0) {
							shortsArray[i].isVideo = true;
						}

						if (i % 9 == 0) {
							shortsArray[i].isVideo = true;
						}
					} else {
						if (i % 6 == 0) {
							shortsArray[i].isVideo = true;
						}

						if (i % 8 == 0) {
							shortsArray[i].isVideo = true;
						}
					}

					if (isr == 1) {
						shorts1.value.push(shortsArray[i]);
						isr = 2;
					} else if (isr == 2) {
						shorts2.value.push(shortsArray[i]);
						if (wstore.value.mobile) {
							isr = 1;
						} else {
							isr = 3;
						}
					} else if (isr == 3) {
						shorts3.value.push(shortsArray[i]);
						isr = 4;
					} else if (isr == 4) {
						shorts4.value.push(shortsArray[i]);
						isr = 1;
					}
				}

				if (shortsArray.length < wstore.value.limit) {
					isEnd.value = true;
					console.log("isEnd true");
				}
			} catch (e) {
				console.error(e);
			} finally {
				init_load.value = true;
				loading.value = false;
			}
		});
};

//동시접속

const initFb = async () => {
	db = getDatabase();
};

const roomRef = async () => {
	await connectRoom();
};

const connectRoom = async () => {
	let dbref = query(fbRef(db, roomPath));
	unsubscribeChat = onValue(dbref, (snapshot) => {
		const data = snapshot.val();
		realTimeCnt.value = Object.keys(data || {}).length;
	});
};

const userAdd = async () => {
	let data = {
		created: dayjs().format("YYYY-MM-DD HH:mm:ss"),
	};

	let path = roomPath + "/" + UUID.value;

	let dbRefSet = fbRef(db, path);

	set(dbRefSet, data)
		.then(() => {})
		.catch((error) => {
			//console.log("!!error", error);
		});

	//접속 종료시 삭제
	onDisconnect(dbRefSet).set([]);
};

const config = {
	showUi: true,
	placeholder: `%n명이 함께 보고있습니다.`,
	visibleCnt: 1,
	position: "top",
	timeout: 5000,
};

//mounted()
onMounted(async () => {
	//계정 환경설정 로드
	await store.getL24Config();

	//console.log("!@!@", window.l24Id);

	roomPath = "showcase/" + window.l24Id;

	wstore.value = { ...wstore.value, ...props.options };

	wstore.value.colspan = parseInt(wstore.value.colspan);
	wstore.value.limit = parseInt(wstore.value.limit);

	loading.value = true;

	if (document.querySelector(".l24TraConter").clientWidth < 762) {
		wstore.value.mobile = true;
		wstore.value.cardGap = "15px";
		wstore.value.marginTop = "20px";
		wstore.value.marginBottom = "20px";
		wstore.value.marginLeft = "10px";
		wstore.value.marginRight = "10px";
	} else {
		wstore.value.mobile = false;
		wstore.value.cardGap = "35px";

		wstore.value.marginTop = "50px";
		wstore.value.marginBottom = "50px";
		wstore.value.marginLeft = "5px";
		wstore.value.marginRight = "5px";
	}

	wstore.value.maxWidth = "1280px";

	await checkUnpaid();
	// await getPage();

	try {
		const io = new IntersectionObserver(ovCallBack, { threshold: 0.7 });
		io.observe(document.getElementById("ovTargetDiv"));
	} catch (e) {}

	setTimeout(async () => {
		initLoadRet.value = true;
		await initFb();
		await roomRef();
		await userAdd();
		setTimeout(() => {
			//initLoadRet.value = false;
		}, 10000);
	}, 3000);

	window.addEventListener("resize", () => {
		if (document.querySelector(".l24TraConter").clientWidth < 762) {
			wstore.value.mobile = true;
		} else {
			wstore.value.mobile = false;
		}
	});
});
</script>

<template>
	<div
		:style="{
			backgroundColor: wstore.backgroundColor,
		}"
		class="l24-wrapper l24TraConter"
		:class="{ 'l24-mobile': wstore.mobile }"
	>
		<div
			v-if="init_load"
			style="margin: auto"
			:style="{
				maxWidth: wstore.maxWidth,
				width: '100%',
				paddingTop: wstore.marginTop,
				paddingBottom: wstore.marginBottom,
				paddingLeft: wstore.marginLeft,
				paddingRight: wstore.marginRight,
			}"
		>
			<div
				:style="{
					gap: wstore.cardGap,
				}"
				style="display: flex"
			>
				<div class="flex-1">
					<showCaseBox :shorts="shorts1" :wstore="wstore" />

					<div v-if="pageNo < 2 && shorts1?.length < 1">
						<UiSkl
							width="100%"
							height="100%"
							style="margin-bottom: 10px; aspect-ratio: 1/1"
							:borderRadius="0"
						/>
					</div>
				</div>
				<div class="flex-1">
					<showCaseBox :shorts="shorts2" :wstore="wstore" />

					<div v-if="pageNo < 2 && shorts2?.length < 1">
						<UiSkl
							width="100%"
							height="100%"
							style="margin-bottom: 10px; aspect-ratio: 1/1"
							:borderRadius="0"
						/>
					</div>
				</div>
				<div class="flex-1" v-if="!wstore.mobile">
					<showCaseBox :shorts="shorts3" :wstore="wstore" />
					<div v-if="pageNo < 2 && shorts3?.length < 1">
						<UiSkl
							width="100%"
							height="100%"
							style="margin-bottom: 10px; aspect-ratio: 1/1"
							:borderRadius="0"
						/>
					</div>
				</div>
				<div class="flex-1" v-if="!wstore.mobile">
					<showCaseBox :shorts="shorts4" :wstore="wstore" />
					<div v-if="pageNo < 2 && shorts4?.length < 1">
						<UiSkl
							width="100%"
							height="100%"
							style="margin-bottom: 10px; aspect-ratio: 1/1"
							:borderRadius="0"
						/>
					</div>
				</div>
			</div>

			<div style="height: 10px; position: relative">
				<div id="ovTargetDiv" style="position: absolute; top: -80px; width: 100%; height: 1px"></div>
			</div>
		</div>
	</div>

	<div
		v-if="init_load"
		style="
			position: fixed;

			left: 0;

			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 9;
			-webkit-transform: translateZ(0);
		"
		class="l24notipos"
	>
		<div
			v-if="realTimeCnt > 10"
			style="
				background-color: #3459cd;
				color: #fff;
				padding: 5px 20px;
				border-radius: 50px;
				font-size: 14px;
				animation-duration: 0.2s;
			"
			class="animate__animated"
			:class="{
				' animate__fadeInUp': initLoadRet,
				' animate__fadeOutDown': !initLoadRet,
			}"
		>
			{{ config.placeholder.replace("%n", realTimeCnt.toLocaleString()) }}
		</div>
	</div>
</template>

<style>
.l24TraConter {
	container-name: showcase-main-container;
	container-type: inline-size;
}
</style>
<style scoped>
.l24TraConter {
	display: flex;
	justify-items: center;
}
.flex-1 {
	flex: 1 1 auto;
	max-width: 25%;
	min-width: 24%;
}

.l24-mobile .grid {
	display: grid;
	grid-template-columns: repeat(2, 1fr) !important;
	grid-gap: 10px;
}

.l24notipos {
	bottom: 25px;
}
@container showcase-main-container  (max-width: 768px) {
	.flex-1 {
		flex: 1;
		max-width: 50%;
		min-width: 48%;
	}

	.l24notipos {
		bottom: 10px;
	}
}
</style>
